export default __webpack_public_path__ + "media/images/home/slide_near_sea_2026_sm-f6b3471a6a2f39588b443292567ab9a5.jpg";